import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { useAuth } from '../../contexts/AuthContext';

interface SubscriptionGuardProps {
  children: React.ReactNode;
}

/**
 * Componente que bloqueia acesso se a assinatura estiver expirada
 * Redireciona para página de assinatura se necessário
 */
export const SubscriptionGuard: React.FC<SubscriptionGuardProps> = ({
  children,
}) => {
  const { role } = useAuth();
  const { isActive, subscription, loading, error, refresh } = useSubscription();

  // Only known non-subscriber profiles bypass the subscription gate.
  if (role === 'patient' || role === 'admin') {
    return <>{children}</>;
  }

  // Aguarda carregamento
  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Carregando...
      </div>
    );
  }

  if (error && (!subscription || !isActive)) {
    return <div role="alert" style={{ padding: '2rem', textAlign: 'center' }}>
      <p>{error}</p>
      <button onClick={() => refresh()}>Tentar novamente</button>
    </div>;
  }

  // Se não tem assinatura ou está expirada, redireciona
  if (!subscription || !isActive) {
    return <Navigate to="/subscription" replace />;
  }

  return <>
    {error && <div role="alert" style={{ padding: '0.75rem 1rem' }}>
      <span>{error} </span>
      <button type="button" onClick={() => { void refresh(); }}>Tentar novamente</button>
    </div>}
    <React.Fragment key="protected-content">{children}</React.Fragment>
  </>;
};

